import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-6">{aboutData.title}</h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4 mb-10">
            {aboutData.description.split('\n\n').map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-xl bg-background-100 border border-background-200/60 p-5"
              >
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">{stat.value}</div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}